<template>
    <div class="row card p-3 mx-0 border border-nmidfour rounded">
        <div class="col">
            <h6 class="bold c-nmidone text-uppercase">
                razão social
            </h6>
            <p class="medium c-ndarkthree text-uppercase">
                {{name}}.
            </p>
        </div>
    </div>
</template>

<script>
export default {
    props: ['name']
}
</script>

<style>

</style>
